//#region src/__generated__/external/application/types/CreateRequestBody.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createRequestBodyAdjoiningTypeEnum = {
	DIRECT_RZD: "DIRECT_RZD",
	VIA_OTHER_OWNER: "VIA_OTHER_OWNER"
};
const createRequestBodyApplicantTypeEnum = {
	INDIVIDUAL: "INDIVIDUAL",
	SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
	LEGAL_ENTITY: "LEGAL_ENTITY"
};
const createRequestBodyPlannedWorksTypeEnum = {
	NEW_TRACK_CONSTRUCTION: "NEW_TRACK_CONSTRUCTION",
	RECONSTRUCTION: "RECONSTRUCTION",
	RESTORATION: "RESTORATION",
	DEVELOPMENT: "DEVELOPMENT"
};
const createRequestBodyRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const createRequestBodyRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const createRequestBodyTrackFundingEnum = {
	APPLICANT_FUNDS: "APPLICANT_FUNDS",
	RZD_INVESTMENT: "RZD_INVESTMENT",
	SHARED: "SHARED",
	OTHER: "OTHER"
};
const createRequestBodyTypeEnum = {
	TU_ISSUE: "TU_ISSUE",
	TU_CHANGE: "TU_CHANGE",
	APPROVAL: "APPROVAL"
};
//#endregion
//#region src/__generated__/external/application/types/FinalDecisionResponse.ts
const finalDecisionResponseDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/external/application/types/GetOperatorFilterValues.ts
const getOperatorFilterValuesColumn = {
	OPERATOR: "OPERATOR",
	INITIATOR: "INITIATOR"
};
//#endregion
//#region src/__generated__/external/application/types/GetOperatorRequests.ts
const getOperatorRequestsStatusEnum = {
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED"
};
const getOperatorRequestsProcessingFlagEnum = {
	TOTAL: "TOTAL",
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED",
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
const getOperatorRequestsRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const getOperatorRequestsSortBy = {
	NUMBER: "NUMBER",
	TITLE: "TITLE",
	STATUS: "STATUS",
	RECEIVED_AT: "RECEIVED_AT",
	PROCESSING_FLAG: "PROCESSING_FLAG",
	PROCESSED_AT: "PROCESSED_AT",
	RAILWAY: "RAILWAY",
	OPERATOR: "OPERATOR",
	INITIATOR: "INITIATOR"
};
const getOperatorRequestsSortDir = {
	ASC: "ASC",
	DESC: "DESC"
};
//#endregion
//#region src/__generated__/external/application/types/GetRequests.ts
const getRequestsStatusEnum = {
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED"
};
const getRequestsPaymentConditionEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
const getRequestsRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const getRequestsRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const getRequestsSortBy = {
	NUMBER: "NUMBER",
	TITLE: "TITLE",
	REQUEST_SUBJECT: "REQUEST_SUBJECT",
	STATUS: "STATUS",
	RAILWAY: "RAILWAY",
	PAYMENT_CONDITION: "PAYMENT_CONDITION",
	APPLICANT_NAME: "APPLICANT_NAME",
	CREATED_AT: "CREATED_AT",
	UPDATED_AT: "UPDATED_AT"
};
const getRequestsSortDir = {
	ASC: "ASC",
	DESC: "DESC"
};
//#endregion
//#region src/__generated__/external/application/types/RequestDetailResponse.ts
const requestDetailResponseAdjoiningTypeEnum = {
	DIRECT_RZD: "DIRECT_RZD",
	VIA_OTHER_OWNER: "VIA_OTHER_OWNER"
};
const requestDetailResponseApplicantTypeEnum = {
	INDIVIDUAL: "INDIVIDUAL",
	SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
	LEGAL_ENTITY: "LEGAL_ENTITY"
};
const requestDetailResponsePaymentConditionEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
const requestDetailResponsePlannedWorksTypeEnum = {
	NEW_TRACK_CONSTRUCTION: "NEW_TRACK_CONSTRUCTION",
	RECONSTRUCTION: "RECONSTRUCTION",
	RESTORATION: "RESTORATION",
	DEVELOPMENT: "DEVELOPMENT"
};
const requestDetailResponseProcessingFlagEnum = {
	TOTAL: "TOTAL",
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED",
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
const requestDetailResponseRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const requestDetailResponseRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const requestDetailResponseStatusEnum = {
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED"
};
const requestDetailResponseTrackFundingEnum = {
	APPLICANT_FUNDS: "APPLICANT_FUNDS",
	RZD_INVESTMENT: "RZD_INVESTMENT",
	SHARED: "SHARED",
	OTHER: "OTHER"
};
const requestDetailResponseTypeEnum = {
	TU_ISSUE: "TU_ISSUE",
	TU_CHANGE: "TU_CHANGE",
	APPROVAL: "APPROVAL"
};
//#endregion
//#region src/__generated__/external/application/types/RequestEventLogDto.ts
const requestEventLogDtoEventTypeEnum = {
	SUBMIT: "SUBMIT",
	EDIT: "EDIT",
	DELETE: "DELETE",
	REJECT: "REJECT",
	EXPORT: "EXPORT",
	IMPORT_RESULT: "IMPORT_RESULT",
	INVOICE_IMPORTED: "INVOICE_IMPORTED",
	PAYMENT_PROOF_UPLOADED: "PAYMENT_PROOF_UPLOADED",
	PAYMENT_PROOF_DELETED: "PAYMENT_PROOF_DELETED",
	PAYMENT_NOTIFIED: "PAYMENT_NOTIFIED"
};
//#endregion
//#region src/__generated__/external/application/types/RequestListItem.ts
const requestListItemApplicantTypeEnum = {
	INDIVIDUAL: "INDIVIDUAL",
	SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
	LEGAL_ENTITY: "LEGAL_ENTITY"
};
const requestListItemPaymentConditionEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
const requestListItemProcessingFlagEnum = {
	TOTAL: "TOTAL",
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED",
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
const requestListItemRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const requestListItemRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const requestListItemStatusEnum = {
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED"
};
const requestListItemTypeEnum = {
	TU_ISSUE: "TU_ISSUE",
	TU_CHANGE: "TU_CHANGE",
	APPROVAL: "APPROVAL"
};
//#endregion
//#region src/__generated__/external/application/types/ResultImportItem.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resultImportItemOutcomeEnum = {
	APPLIED: "APPLIED",
	FAILED: "FAILED"
};
//#endregion
//#region src/__generated__/external/application/types/ResultImportPayload.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resultImportPayloadOutcomeEnum = {
	REVISION_REQUIRED: "REVISION_REQUIRED",
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/external/application/types/TileCount.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const tileCountKeyEnum = {
	TOTAL: "TOTAL",
	DRAFT: "DRAFT",
	IN_REVIEW: "IN_REVIEW",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	WAITING_PAYMENT: "WAITING_PAYMENT",
	RESOLVED_APPROVED: "RESOLVED_APPROVED",
	RESOLVED_REJECTED: "RESOLVED_REJECTED",
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
//#endregion
//#region src/__generated__/external/application/types/UpdateDraftRequestBody.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateDraftRequestBodyAdjoiningTypeEnum = {
	DIRECT_RZD: "DIRECT_RZD",
	VIA_OTHER_OWNER: "VIA_OTHER_OWNER"
};
const updateDraftRequestBodyApplicantTypeEnum = {
	INDIVIDUAL: "INDIVIDUAL",
	SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
	LEGAL_ENTITY: "LEGAL_ENTITY"
};
const updateDraftRequestBodyPlannedWorksTypeEnum = {
	NEW_TRACK_CONSTRUCTION: "NEW_TRACK_CONSTRUCTION",
	RECONSTRUCTION: "RECONSTRUCTION",
	RESTORATION: "RESTORATION",
	DEVELOPMENT: "DEVELOPMENT"
};
const updateDraftRequestBodyRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const updateDraftRequestBodyRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const updateDraftRequestBodyTrackFundingEnum = {
	APPLICANT_FUNDS: "APPLICANT_FUNDS",
	RZD_INVESTMENT: "RZD_INVESTMENT",
	SHARED: "SHARED",
	OTHER: "OTHER"
};
const updateDraftRequestBodyTypeEnum = {
	TU_ISSUE: "TU_ISSUE",
	TU_CHANGE: "TU_CHANGE",
	APPROVAL: "APPROVAL"
};
//#endregion
export { getRequestsRailwayEnum as A, getOperatorFilterValuesColumn as B, requestDetailResponseProcessingFlagEnum as C, requestDetailResponseTrackFundingEnum as D, requestDetailResponseStatusEnum as E, getOperatorRequestsProcessingFlagEnum as F, createRequestBodyRailwayEnum as G, createRequestBodyAdjoiningTypeEnum as H, getOperatorRequestsRailwayEnum as I, createRequestBodyTypeEnum as J, createRequestBodyRequestSubjectEnum as K, getOperatorRequestsSortBy as L, getRequestsSortBy as M, getRequestsSortDir as N, requestDetailResponseTypeEnum as O, getRequestsStatusEnum as P, getOperatorRequestsSortDir as R, requestDetailResponsePlannedWorksTypeEnum as S, requestDetailResponseRequestSubjectEnum as T, createRequestBodyApplicantTypeEnum as U, finalDecisionResponseDecisionEnum as V, createRequestBodyPlannedWorksTypeEnum as W, requestListItemTypeEnum as _, updateDraftRequestBodyRequestSubjectEnum as a, requestDetailResponseApplicantTypeEnum as b, tileCountKeyEnum as c, requestListItemApplicantTypeEnum as d, requestListItemPaymentConditionEnum as f, requestListItemStatusEnum as g, requestListItemRequestSubjectEnum as h, updateDraftRequestBodyRailwayEnum as i, getRequestsRequestSubjectEnum as j, getRequestsPaymentConditionEnum as k, resultImportPayloadOutcomeEnum as l, requestListItemRailwayEnum as m, updateDraftRequestBodyApplicantTypeEnum as n, updateDraftRequestBodyTrackFundingEnum as o, requestListItemProcessingFlagEnum as p, createRequestBodyTrackFundingEnum as q, updateDraftRequestBodyPlannedWorksTypeEnum as r, updateDraftRequestBodyTypeEnum as s, updateDraftRequestBodyAdjoiningTypeEnum as t, resultImportItemOutcomeEnum as u, requestEventLogDtoEventTypeEnum as v, requestDetailResponseRailwayEnum as w, requestDetailResponsePaymentConditionEnum as x, requestDetailResponseAdjoiningTypeEnum as y, getOperatorRequestsStatusEnum as z };

//# sourceMappingURL=UpdateDraftRequestBody.js.map